<div class="cart-totals-coupon">
  <div class="cart-totals-coupon-inner">
    <form
      class="cart-totals-coupon-form"
      [class.form-loading]="isLoadingCoupon()"
      [formGroup]="form"
      (ngSubmit)="applyVoucher()"
    >
      @if (!isLoadingCoupon()) {
        <input
          class="cart-totals-coupon-input text-b4-m-500 text-md-b4-l-500"
          type="text"
          formControlName="coupon"
          placeholder="промокод / сертификат"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
        />

        @if (isError()) {
          <button class="cart-totals-coupon-button btn-icon" type="button" (click)="removeVoucher()">
            <sd-icon [type]="iconTypes.CROSS"></sd-icon>
          </button>
        } @else {
          <button
            class="cart-totals-coupon-button btn-icon"
            [class.has-value]="hasValue()"
            type="submit"
            [disabled]="!hasValue()"
          >
            <sd-icon [type]="iconTypes.ARROW_NEXT"></sd-icon>
          </button>
        }
      } @else {
        <sd-cart-totals-coupon-loader></sd-cart-totals-coupon-loader>
      }
    </form>

    @if (errorMessage() && !isLoadingCoupon()) {
      <div class="text-b4-s-500 color-red">
        {{ errorMessage() }}
      </div>
    }
  </div>

  @if (appliedCertificates() || appliedVouchers()) {
    <div class="cart-totals-coupon-list">
      @if (appliedCertificates(); as appliedCertificates) {
        <div class="cart-totals-coupon-list-item">
          <div class="text-c1-m-500 text-md-b4-m-500 color-green">
            сертификат применён | остаток на балансе {{ appliedCertificates.freeAmount }} ₽
          </div>
          <button class="text-b4-m-300 color-black-warm btn-icon" (click)="removeVoucher(appliedCertificates.code)">
            отменить сертификат
          </button>
        </div>
      }
      @if (appliedVouchers(); as appliedVouchers) {
        <div class="cart-totals-coupon-list-item">
          <div class="text-c1-m-500 text-md-b4-m-500 color-green">промокод применён</div>
          <button class="text-b4-m-300 color-black-warm btn-icon" (click)="removeVoucher(appliedVouchers.voucherCode)">
            отменить промокод
          </button>
        </div>
      }
    </div>
  }
</div>
